import DoneIcon from "@mui/icons-material/Done";
import React from "react";
import subjectSelectionService from "../../../services/subjectSelectionService";
import IconLock from "../../../assets/images/icons/circle-lock.svg?react";

const SubjectButton = (props) => {
    const {
        subjectsSelected,
        subject,
        packageProduct,
        onSubjectClick,
        isHigherSelection,
        disabled,
    } = props;

    const {
        isLocked,
        isSelected,
        isDisabled,
    } = subjectSelectionService.getSubjectVariant(
        subject,
        packageProduct,
        subjectsSelected,
        isHigherSelection,
    );

    return (
        <button
            type="button"
            disabled={disabled || isLocked || (isSelected ? false : isDisabled)}
            className={`add-student-selection-option add-student-selection-option--subject ${isSelected ? "selected" : ""} ${isLocked ? "locked" : ""}`}
            onClick={() => onSubjectClick(subject)}
        >
            <span className="add-student-selection-option__icon">
                {isLocked && <IconLock className="add-student-selection-option__lock" />}
                {(!isLocked && isSelected) && <DoneIcon />}
            </span>
            <span className="add-student-selection-option__primary-text">{subject.name}</span>
        </button>
    );
};

export default SubjectButton;
